import * as Yup from 'yup';

export const emailSchema = Yup.string().email('Invalid email').required('Email is required');

export const passwordSchema = Yup.string()
  .min(8, 'Password must be at least 8 characters')
  .matches(/[A-Z]/, 'Must contain uppercase letter')
  .matches(/[0-9]/, 'Must contain a number')
  .required('Password is required');

export const loginPasswordSchema = Yup.string()
  .min(6, 'Min 6 characters')
  .required('Password is required');

export const loginSchema = Yup.object({
  email: emailSchema,
  password: loginPasswordSchema,
  remember: Yup.boolean(),
});

export const forgotPasswordSchema = Yup.object({
  email: emailSchema,
});

export const resetPasswordSchema = Yup.object({
  password: passwordSchema,
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords must match')
    .required('Confirm password is required'),
});

export const adminResetPasswordSchema = Yup.object({
  newPassword: passwordSchema,
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword')], 'Passwords must match')
    .required('Confirm password is required'),
});
